/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = None 1 = SEO 2 = AIScraper 3 = AITool 4 = Tool 5 = Ads 6 = Preview 7 = Social 255 = System
 */
export type BotCategory = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const BotCategory = {
  None: 0 as BotCategory,
  SEO: 1 as BotCategory,
  AIScraper: 2 as BotCategory,
  AITool: 3 as BotCategory,
  Tool: 4 as BotCategory,
  Ads: 5 as BotCategory,
  Preview: 6 as BotCategory,
  Social: 7 as BotCategory,
};
